<template>
  <b-row>
    <b-col sm="6">
      <b-form-group
          label-cols-sm="4"
          :label="$t('createShipment.label.Senders Reference')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10">
            <b-form-input
                size="sm"
                type="text"
                v-model="shipment.texts.sendersReference"
                name="shipment.texts.sendersReference"
                :class="{
                                'is-invalid': v.shipment.texts.sendersReference.$error
                            }"
                aria-describedby="sendersReference-feedback"
                @update="v.shipment.texts.sendersReference.$touch()"
            />

            <b-form-invalid-feedback
                id="sendersReference-feedback"
                name="shipment.texts.sendersReference.error"
                v-if="v.shipment.texts.sendersReference.$error"
            >
              <validationMaxLength
                  fieldName="createShipment.label.Senders Reference"
                  :fieldValid="v.shipment.texts.sendersReference.maxLength"
                  :fieldMax="v.shipment.texts.sendersReference.$params.maxLength.max"
              />

              <validationRequired
                  fieldName="createShipment.label.Senders Reference"
                  :fieldValid="v.shipment.texts.sendersReference.required"
              />
            </b-form-invalid-feedback>
          </b-col>

          <b-input-group-append v-if="required(fieldNames.SENDERS_REFERENCE)">
            <div>
              <requiredIcon
                  :active="hasShipmentOptions"
              />
            </div>
          </b-input-group-append>

        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col sm="6">
      <b-form-group
          label-cols-sm="4"
          :label="$t('createShipment.label.Receivers Reference')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10">
            <b-form-input
                size="sm"
                type="text"
                name="shipment.texts.receiversReference"
                v-model="shipment.texts.receiversReference"
                :class="{
                                'is-invalid': v.shipment.texts.receiversReference.$error
                            }"
                aria-describedby="receiversReference-feedback"
                @update="v.shipment.texts.receiversReference.$touch()"
            />
            <b-form-invalid-feedback
                id="receiversReference-feedback"
                name="shipment.texts.receiversReference.error"
                v-if="v.shipment.texts.receiversReference.$error"
            >
              <validationMaxLength
                  fieldName="createShipment.label.Receivers Reference"
                  :fieldValid="v.shipment.texts.receiversReference.maxLength"
                  :fieldMax="
                                    v.shipment.texts.receiversReference.$params.maxLength.max
                                "
              />

              <validationRequired
                  fieldName="createShipment.label.Receivers Reference"
                  :fieldValid="v.shipment.texts.receiversReference.required"
              />
            </b-form-invalid-feedback>
          </b-col>

          <b-input-group-append v-if="required(fieldNames.RECEIVERS_REFERENCE)">
            <div>
              <requiredIcon
                  :active="hasShipmentOptions"
              />
            </div>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col sm="6" v-if="display(fieldNames.MULTI_REFERENCE)">
      <b-form-group
          label-cols-sm="4"
          :label="$t('createShipment.label.Reference Type')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10">
            <vSelect
                :dynamicWidth="true"
                :placeholder="$t('createShipment.placeholder.Choose Reference Type')"
                :options="referenceTypes"
                label="name"
                v-model="shipment.texts.reference.type"
                :reduce="(reference) => reference.type"
                :clearable="false"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col sm="6" v-if="display(fieldNames.MULTI_REFERENCE)">
      <b-form-group
          label-cols-sm="4"
          :label="$t('createShipment.label.Ref')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="10">
            <b-form-input
                size="sm"
                type="text"
                v-model="shipment.texts.reference.value"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import viewOptions from '../mixins/viewOptionsMixin';
import vSelect from './vSelect';
import { ACTIONS } from '../store/constants';
import { FIELD_NAMES } from '../store/nameConstants';
import { mapState } from 'vuex';
import requiredIcon from './requiredIcon';
import validationMaxLength from './Validation/ValidationMaxLength';
import validationRequired from './Validation/ValidationRequired';
import { mapGetters } from 'vuex';

export default {
  components: {
    requiredIcon,
    validationMaxLength,
    validationRequired,
    vSelect,
  },
  props: {
    shipment: {
      required: true
    },
    v: {required: true}
  },
  mixins: [viewOptions],
  mounted() {
    this.shipment.texts.reference = {type: 'InvoiceReference', value: ''};
  },
  computed: {
    ...mapGetters('createShipment', ['hasShipmentOptions'])
  },
  data() {
    return {
      fieldNames: FIELD_NAMES,
      referenceTypes: [{type: 'InvoiceReference', name: 'Invoice'}] //Reference Database-table is currently corrupt so this is used as of now.
    };
  },
}
</script>

<style>
</style>
